module.exports = {
	"_args": [
		[
			"gb-tracker-client@^3.0.2",
			"/home/ubuntu/searchandiser-ui"
		]
	],
	"_from": "gb-tracker-client@>=3.0.2 <4.0.0",
	"_id": "gb-tracker-client@3.0.2",
	"_inCache": true,
	"_installable": true,
	"_location": "/gb-tracker-client",
	"_nodeVersion": "6.4.0",
	"_npmOperationalInternal": {
		"host": "packages-12-west.internal.npmjs.com",
		"tmp": "tmp/gb-tracker-client-3.0.2.tgz_1476304247523_0.3890618016012013"
	},
	"_npmUser": {
		"email": "ops@groupbyinc.com",
		"name": "groupby"
	},
	"_npmVersion": "3.10.3",
	"_phantomChildren": {
		"debug": "2.2.0",
		"diff": "1.4.0",
		"growl": "1.9.2",
		"inherits": "2.0.3",
		"jade": "0.26.3",
		"lru-cache": "2.2.4",
		"mkdirp": "0.5.1",
		"sigmund": "1.0.1",
		"to-iso-string": "0.0.2"
	},
	"_requested": {
		"name": "gb-tracker-client",
		"raw": "gb-tracker-client@^3.0.2",
		"rawSpec": "^3.0.2",
		"scope": null,
		"spec": ">=3.0.2 <4.0.0",
		"type": "range"
	},
	"_requiredBy": [
		"/"
	],
	"_resolved": "https://registry.npmjs.org/gb-tracker-client/-/gb-tracker-client-3.0.2.tgz",
	"_shasum": "a5bef6763917626722e51f78c1979b3e32953f74",
	"_shrinkwrap": null,
	"_spec": "gb-tracker-client@^3.0.2",
	"_where": "/home/ubuntu/searchandiser-ui",
	"author": {
		"name": "Eric Hacke"
	},
	"bugs": {
		"url": "https://github.com/groupby/gb-tracker-client/issues"
	},
	"dependencies": {
		"deep-diff": "^0.3.4",
		"json-loader": "^0.5.4",
		"lz-string": "^1.4.4",
		"mocha": "^2.4.5",
		"schema-inspector": "^1.6.4",
		"uuid": "^2.0.2"
	},
	"description": "GroupBy client-side event tracker",
	"devDependencies": {
		"chai": "^3.5.0",
		"codacy-coverage": "^2.0.0",
		"gulp": "^3.9.1",
		"gulp-eslint": "^2.0.0",
		"gulp-exec": "^2.1.2",
		"gulp-if": "^2.0.1",
		"gulp-istanbul": "^0.10.4",
		"gulp-mocha": "^2.2.0",
		"gulp-util": "^3.0.7",
		"istanbul": "^0.4.3",
		"lodash": "^4.15.0",
		"stream-combiner2": "^1.1.1",
		"stringify-object": "^2.4.0",
		"supertest": "^1.2.0",
		"supertest-as-promised": "^3.1.0",
		"webpack": "^1.13.1",
		"webpack-stream": "^3.2.0"
	},
	"directories": {},
	"dist": {
		"shasum": "a5bef6763917626722e51f78c1979b3e32953f74",
		"tarball": "https://registry.npmjs.org/gb-tracker-client/-/gb-tracker-client-3.0.2.tgz"
	},
	"homepage": "https://github.com/groupby/gb-tracker-client#readme",
	"keywords": [
		"groupby",
		"tracker",
		"recommendations"
	],
	"license": "MIT",
	"main": "index.js",
	"maintainers": [
		{
			"email": "ops@groupbyinc.com",
			"name": "groupby"
		}
	],
	"name": "gb-tracker-client",
	"optionalDependencies": {},
	"readme": "ERROR: No README data found!",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/groupby/gb-tracker-client.git"
	},
	"scripts": {
		"coverage:codacy": "cat ./coverage/lcov.info | codacy-coverage",
		"test": "gulp test"
	},
	"version": "3.0.2"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/gb-tracker-client/package.json
 ** module id = 163
 ** module chunks = 0
 **/